import React from 'react';
import { useIsMobile } from '../hooks/use-media-query';
import { cn } from '../lib/utils';

// Thumb-friendly action bar pinned to the bottom of the screen on phones only.
// Renders nothing on md+; on mobile it fixes its children to the bottom and
// pushes up above the mobile nav. Pages should add `pb-24 md:pb-0` (or use the
// <MobileActionBarSpacer/>) so content isn't hidden behind it.
export function MobileActionBar({ children, className, testid = 'mobile-action-bar' }) {
  const isMobile = useIsMobile();
  if (!isMobile) return null;
  return (
    <>
      <div aria-hidden className="h-20 md:hidden" />
      <div
        data-testid={testid}
        className={cn(
          'fixed inset-x-0 bottom-0 z-[120] border-t border-border bg-background/95 px-4 py-3 backdrop-blur-md md:hidden',
          'shadow-[0_-6px_20px_-8px_hsl(var(--foreground)/0.25)]',
          className,
        )}
        style={{ paddingBottom: 'max(0.75rem, env(safe-area-inset-bottom))' }}
      >
        <div className="flex items-center gap-2">{children}</div>
      </div>
    </>
  );
}
